module.exports = __webpack_public_path__ + "2d204cbda07040d46a5b4d8c93fc9df3.svg";